import { useMemo, useState } from 'react'

import { filterShippingMethods } from './helpers'

const useFilter = shippingMethods => {
  const [filters, setFilters] = useState({})

  const filteredShippingMethods = useMemo(() => {
    return filterShippingMethods(shippingMethods, filters)
  }, [shippingMethods, filters])

  return {
    filteredShippingMethods,
    filters,
    setFilters,
  }
}

export default useFilter
